import React, { useContext, useState } from 'react';
import { Field, FieldRenderProps, Form, FormRenderProps } from 'react-final-form';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { FormContent, Input, LocaleContext, ReCaptchaPolicy } from 'shared';
import { combineValidators, required, validateEmail } from 'utils/formValidators';

import { LoginLink, SubmitButton } from './ResetPasswordForm.styles';
import { ResetPasswordFormProps } from './ResetPasswordForm.types';

export const ResetPasswordForm = ({
  onSubmit,
  isSubmitFailed,
  onShowLoginForm,
  reCaptchaKey,
}: ResetPasswordFormProps) => {
  const localeContext = useContext(LocaleContext);
  const [isCaptchaFilled, setCaptchaFilled] = useState(false);

  const handleVerifyCaptcha = (change: (name: string, value?: any) => void) => (response: string) => {
    change('captchaResponse', response);
    setCaptchaFilled(true);
  };

  return (
    <FormContent className="form reset-password-form">
      <Form onSubmit={onSubmit} validateOnBlur={false}>
        {({ handleSubmit, submitting, form: { change } }: FormRenderProps) => {
          return (
            <form onSubmit={handleSubmit} action="">
              <Field
                name="email"
                validate={combineValidators(
                  required(localeContext.formatMessage({ id: 'FORM.REQUIRED' })),
                  validateEmail(localeContext.formatMessage({ id: 'FORM.INVALID-EMAIL' })),
                )}
              >
                {({ input, meta }: FieldRenderProps<HTMLInputElement>) => (
                  <Input
                    label={localeContext.formatMessage({ id: 'RESET-PASSWORD.FORM.EMAIL' })}
                    input={input}
                    meta={{
                      ...meta,
                      submitError: isSubmitFailed
                        ? localeContext.formatMessage({ id: 'RESET-PASSWORD.FORM.FAILED' })
                        : meta.submitError,
                    }}
                    className="reset-password-form__email"
                  />
                )}
              </Field>

              <GoogleReCaptcha key={reCaptchaKey} onVerify={handleVerifyCaptcha(change)} />

              <ReCaptchaPolicy />

              <LoginLink onClick={onShowLoginForm} className="reset-password-form__login">
                {localeContext.formatMessage({ id: 'RESET-PASSWORD.FORM.LOGIN' })}
              </LoginLink>

              <SubmitButton
                type="leading"
                className="reset-password-form__submit"
                disabled={submitting || !isCaptchaFilled}
              >
                {localeContext.formatMessage({ id: 'RESET-PASSWORD.FORM.CONFIRM' })}
              </SubmitButton>
            </form>
          );
        }}
      </Form>
    </FormContent>
  );
};
